import React from "react";
import {
    BarChart3,
    ClipboardList,
    Handshake,
    NotebookPen,
    Percent,
    Ship,
} from "lucide-react";
import ReportDataGrid from "@/components/reports/layout/ReportDataGrid";
import ReportStatCard from "@/components/reports/layout/ReportStatCard";
import {
    reportAccent,
    reportAccentGreen,
    reportBodyText,
    reportCard,
    reportHeading,
    reportSectionTitle,
    reportShell,
    reportShellBody,
} from "@/components/reports/layout/reportTheme";
import {
    formatReportCurrency,
    formatReportDisplayDate,
    getExportBookingReportByLabel,
} from "@/utility/fclReportHelpers";
import {
    EXPORT_BOOKING_LIST_COLUMNS,
    EXPORT_CONTAINER_TEUS_COLUMNS,
} from "./exportBookingReportColumns";

const ExportBookingReportView = ({ filters, summary = {}, containerTeusList = [], bookingList = [] }) => {
    const totalBooking = summary.totalBooking ?? summary.TotalBooking ?? 0;
    const totalSell = summary.totalSellRate ?? summary.TotalSellRate ?? 0;
    const totalBuy = summary.totalBuyRate ?? summary.TotalBuyRate ?? 0;
    const totalProfit = summary.totalProfit ?? summary.TotalProfit ?? 0;
    const totalTeus = summary.totalTeus ?? summary.TotalTeus ?? 0;

    const fromLabel = formatReportDisplayDate(filters?.FromDate);
    const toLabel = formatReportDisplayDate(filters?.ToDate);
    const reportByLabel = getExportBookingReportByLabel(filters?.ReportBy);

    return (
        <div className="space-y-3">
            <div className={`${reportShell} text-center`}>
                <div className={`${reportShellBody} py-5`}>
                    <h2 className={`text-lg sm:text-xl font-bold ${reportHeading}`}>Booking Report Summary</h2>
                    <p className={`mt-2 text-[13px] ${reportBodyText}`}>
                        From <span className={`font-semibold ${reportAccentGreen}`}>{fromLabel}</span> to{" "}
                        <span className={`font-semibold ${reportAccentGreen}`}>{toLabel}</span>
                        {" · "}Filter by{" "}
                        <span className={`font-semibold ${reportAccentGreen}`}>{reportByLabel}</span>
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-2 sm:gap-3">
                <ReportStatCard icon={NotebookPen} label="Total Booking" value={totalBooking} colorIndex={0} />
                <ReportStatCard
                    icon={Handshake}
                    label="Total Sell Amount"
                    value={formatReportCurrency(totalSell)}
                    colorIndex={1}
                />
                <ReportStatCard
                    icon={Percent}
                    label="Total Buy Amount"
                    value={formatReportCurrency(totalBuy)}
                    colorIndex={2}
                />
                <ReportStatCard
                    icon={BarChart3}
                    label="Total Profit"
                    value={formatReportCurrency(totalProfit)}
                    colorIndex={3}
                />
                <ReportStatCard
                    icon={ClipboardList}
                    label="Total Teus"
                    value={Number(totalTeus).toFixed(2)}
                    colorIndex={4}
                />
            </div>

            <div className={`${reportCard} overflow-hidden`}>
                <div className={reportSectionTitle}>
                    <Ship className={`h-5 w-5 ${reportAccent}`} />
                    <span className={`text-sm font-semibold ${reportHeading}`}>
                        Booking Container Wise Summary Report
                    </span>
                </div>
                <ReportDataGrid
                    gridId="export-booking-container-teus"
                    data={containerTeusList}
                    columns={EXPORT_CONTAINER_TEUS_COLUMNS}
                    emptyText="No container TEU summary for the selected filters."
                    defaultPageSize={10}
                    paginationTitle="container types"
                    bare
                />
            </div>

            <ReportDataGrid
                gridId="export-booking-list"
                data={bookingList}
                columns={EXPORT_BOOKING_LIST_COLUMNS}
                title="Booking List"
                emptyText="No bookings found for the selected filters."
                defaultPageSize={10}
                paginationTitle="bookings"
            />
        </div>
    );
};

export default ExportBookingReportView;
